import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
            return data;
        } catch (e) {
            // Access token expired but refresh token may still be valid.
            // Try to mint a fresh access cookie, then re-fetch the user.
            if (e?.response?.status === 401) {
                try {
                    await api.post("/auth/refresh");
                    const { data } = await api.get("/auth/me");
                    setUser(data);
                    return data;
                } catch {
                    setUser(null);
                    return null;
                }
            }
            setUser(null);
            return null;
        }
    }, []);

    useEffect(() => {
        // If returning from Emergent Google OAuth, AuthCallback will refresh user.
        if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
            setLoading(false);
            return;
        }
        (async () => {
            await refresh();
            setLoading(false);
        })();
    }, [refresh]);

    const logout = async () => {
        try { await api.post("/auth/logout"); } catch (e) { /* noop */ }
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, setUser, loading, refresh, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
